import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Admin from './pages/Admin';
import Firma from './pages/Firma';
import Login from './pages/Login';
import axios from 'axios';
import { setAuthToken } from './services/api';

function App() {
  const [token, setToken] = useState<string | null>(null);
  const [verificando, setVerificando] = useState(true);

  // Al caricamento: prova a ripristinare la sessione via cookie HttpOnly
  useEffect(() => {
    const ripristinaSessione = async () => {
      try {
        const res = await axios.post(
          process.env.REACT_APP_API_URL + '/api/auth/refresh',
          {},
          { withCredentials: true }
        );
        const nuovoToken: string = res.data.access_token;
        setAuthToken(nuovoToken);
        setToken(nuovoToken);
      } catch {
        setToken(null);
      } finally {
        setVerificando(false);
      }
    };
    ripristinaSessione();
  }, []);

  const handleLogin = (nuovoToken: string) => {
    setAuthToken(nuovoToken);
    setToken(nuovoToken);
  };

  const handleLogout = async () => {
    try {
      await axios.post(
        process.env.REACT_APP_API_URL + '/api/auth/logout',
        {},
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
      );
    } catch { /* ignora errori di logout */ }
    setAuthToken(null);
    setToken(null);
  };

  if (verificando) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', fontFamily: 'Arial' }}>
        <p>Caricamento...</p>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        {/* Pagina firma — sempre accessibile senza login */}
        <Route path="/sign/:token" element={<Firma />} />

        {/* Login — accessibile solo se non autenticato */}
        <Route path="/login" element={
          token ? <Navigate to="/" replace /> : <Login onLogin={handleLogin} />
        } />

        {/* Admin — accessibile solo se autenticato */}
        <Route path="/" element={
          token ? <Admin onLogout={handleLogout} /> : <Navigate to="/login" replace />
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;